import React from "react";
import "./BrandMark.css";
import { AnimatedBrandWordmark } from "./AnimatedBrandWordmark";

// Screen finishes are high-resolution 3D renders of the editable vector silhouettes.
// Small fixed-colour icons and print/embroidery use separate solid SVG masters.
export const BrandMark = ({ mark = "wordmark", animated = false, testId, className = "", style, alt = "SAMTWO" }) => animated ? (
  <AnimatedBrandWordmark testId={testId} className={className} style={style} alt={alt} />
) : (
  <img
    src={`${process.env.PUBLIC_URL}/brand/${mark}-satin-3d.webp`}
    onError={(event) => {
      if (!event.currentTarget.src.endsWith(".png")) event.currentTarget.src = `${process.env.PUBLIC_URL}/brand/${mark}-satin-3d.png`;
    }}
    alt={alt}
    data-testid={testId}
    className={`brand-mark brand-mark--${mark} ${className}`}
    style={style}
    width={mark === "clef" ? 380 : 800}
    height={mark === "clef" ? 752 : 242}
    draggable="false"
  />
);

export const PlatformWordmark = () => (
  <div className="platform-wordmark" data-testid="platform-wordmark">
    <BrandMark testId="platform-wordmark-image" />
  </div>
);